import { keyBy } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { FormTemplateApi } from 'api/form';
import { TemplateId } from 'api/models';
import { PageLoading } from 'components/atoms/loading';
import { Page } from 'components/molecules/page/page';
import { WebFormRenderer } from 'components/organisms/forms/web-form-renderer';
import { flattenQuestions } from 'components/organisms/templates/forms/utils';
import { useAccount } from 'hooks/use-account';

export const FormPreview: FC = () => {
  const params = useParams<{ formTemplateId: string }>();
  const templateId = TemplateId(parseInt(params.formTemplateId, 10));
  const { data: formTemplate, isLoading: isFormTemplateLoading } = useQuery(
    ['form-preview', templateId],
    () => {
      return FormTemplateApi.getFormTemplate(templateId);
    },
  );
  const {
    company: { companyName, companyLogoUrl },
  } = useAccount();

  const flattenedQuestionsMap = useMemo(() => {
    const questions = formTemplate?.formQuestions ?? [];

    if (questions) {
      const flattenedQuestions = flattenQuestions(questions);

      return keyBy(flattenedQuestions, 'questionId');
    }

    return {};
  }, [formTemplate?.formQuestions]);

  return (
    <Page>
      {isFormTemplateLoading || !formTemplate ? (
        <PageLoading />
      ) : (
        <Page.Content>
          <WebFormRenderer
            flattenedQuestionsMap={flattenedQuestionsMap}
            formTemplate={formTemplate}
            isPreviewMode
            companyName={companyName}
            companyLogoUrl={companyLogoUrl || ''}
          />
        </Page.Content>
      )}
    </Page>
  );
};
